import { Grid, Typography } from '@material-ui/core'

import UserLogList from '../UserLogList'

const styles = {}

const UserGroupsLogList = ({ records = [], addedItemColor, objProp = 'name', diffProp = 'new' }) => {
   const isHighlighted = item => (item?.[diffProp] ? addedItemColor : 'transparent')
   return (
      <UserLogList
         records={records}
         addedItemColor={addedItemColor}
         buttonTitle="GRUPOS"
         title="Grupos Asignados"
         diffProp={diffProp}
      >
         {records?.map(item => (
            <Grid
               container
               direction="column"
               style={{ borderLeft: `4px solid #ddd`, paddingLeft: 10, background: isHighlighted(item) }}
               key={item?.id + item?.[objProp]}
            >
               <Typography variant="body2">
                  <b>{item?.[objProp]}</b>
               </Typography>
               {item?.roles?.map((rol, idx) => (
                  <Grid item key={rol?.id ?? idx} style={{ padding: 0, background: isHighlighted(rol) }}>
                     <Typography variant="body2">{rol?.name}</Typography>
                  </Grid>
               ))}
            </Grid>
         ))}
      </UserLogList>
   )
}

export default UserGroupsLogList
